import Vue from 'vue';
import VueGtag from 'vue-gtag';

Vue.use(VueGtag, {
  config: { id: 'G-D03QTH56R6' },
});
